import {Component, Input, OnInit} from '@angular/core';
import {I18nService} from '../../../../../shared/services/i18n.service';
import {MatTableDataSource} from '@angular/material/table';
import {Document} from '../business-card-order-details.component';

@Component({
  selector: 'app-order-document-list',
  templateUrl: './order-document-list.component.html',
  styleUrls: ['./order-document-list.component.scss']
})
export class OrderDocumentListComponent implements OnInit {

  @Input() documentTypeLabel: string;

  @Input() displayFields: string[];

  @Input() documents: Document[];

  displayedColumns: any = [];
  keyColumns: any = ['id']; // Columns with link
  datalistsource: MatTableDataSource<any>; // MatTableDataSource

  constructor(
    public i18n: I18nService
  ) { }

  ngOnInit(): void {
    this.displayedColumns = ['templateLabel', ...this.displayFields, 'quantity'];
    this.datalistsource = new MatTableDataSource(this.documents);
  }

  getColumnLabel(fieldName: string) {
    switch (fieldName) {
      case 'quantity':
        return 'Quantity';
      case 'templateLabel':
        return 'Template';
      default:
        return fieldName;
    }
  }

}
